
import Vuex from 'vuex'




export const store =  new Vuex.Store({
	state: {
		rightView: 'user-org-list',
		prop1: '',
		prop2: '',
		userOrgArray: [],
		userOrgComp: '0',
		inviteArray: [],
		inviteComp: '0',



	},

	mutations: {
		setRightView(state, payload) { state.rightView = payload.name; state.prop1 = payload.prop1; state.prop2 = payload.prop2},
		setUserOrgs(state, payload) { state.userOrgArray = payload.info; state.userOrgComp = payload.info1; },
		setUserOrgsComp(state, payload) { state.userOrgComp = payload.info1; },
		
		
  	},

	actions: {
		getRightView(context, payload) { context.commit("setRightView", { name: payload.name, prop1: payload.prop1, prop2: payload.prop2 })  },
		getAllUserOrgs(context, payload) {
			context.commit("setUserOrgsComp", { info1: '0' }) 
			axios.get('/utility/user/org/getallorgsbyuser')
	          	.then(function (response) {
	          		var a = response.data.data;
					if(a == null || a == ''){ var b = []; } else { var b = a; }
			        context.commit("setUserOrgs", { info: b, info1: '1' }) 
	          	});
		},
		
		
		
	}

})